"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultOptions = {
    suppressErrors: true
};
var isJson = function (str) {
    try {
        JSON.parse(str);
        return true;
    }
    catch (e) {
        return false;
    }
};
var isObject = function (item) { return (typeof item === 'object' ? true : false); };
var handleError = function (message, error, options) {
    if (options === void 0) { options = defaultOptions; }
    var suppressErrors = options.suppressErrors;
    if (suppressErrors) {
        console.error(message, error);
    }
    else {
        throw error;
    }
};
/**
 * Client side storage utility to store strings or objects
 * using the Web SessionStorage API
 */
exports.addItem = function (itemKey, itemValue, options) {
    if (options === void 0) { options = defaultOptions; }
    var data = isObject(itemValue) ? JSON.stringify(itemValue) : itemValue;
    var status = false;
    try {
        window.sessionStorage.setItem(itemKey, data);
        status = true;
    }
    catch (error) {
        handleError("Failed to set " + itemKey + " in sessionStorage.\n", error, options);
    }
    return status;
};
/**
 * Client side storage utility to retrieve stored strings or objects
 * using the Web SessionStorage API
 */
exports.getItem = function (itemKey, options) {
    if (options === void 0) { options = defaultOptions; }
    var item = null;
    try {
        item = window.sessionStorage.getItem(itemKey);
    }
    catch (error) {
        handleError("Failed to get " + itemKey + " from sessionStorage.\n", error, options);
    }
    var data = isJson(item) ? JSON.parse(item) : item;
    return data;
};
/**
 * Client side storage utility to deleted stored strings or objects
 * using the Web SessionStorage API
 */
exports.deleteItem = function (itemKey, options) {
    if (options === void 0) { options = defaultOptions; }
    try {
        window.sessionStorage.removeItem(itemKey);
    }
    catch (error) {
        handleError("Failed to remove " + itemKey + " from sessionStorage.\n", error, options);
    }
};
